import React, { useEffect, useContext, useState, useRef } from 'react';
import { Image, Modal, Header, Grid, Icon, Button, Form, Message, Input, Select, Container, List, Card, Divider, Checkbox, Label, Table, Accordion, ModalActions } from 'semantic-ui-react'
import AuthContext from '../../../context/authContext';
import LogoTeamLigaGenerator from '../../../assets/tglogov6_small.png';
import rulesvolleyball from '../../../assets/rulesvolleyball.png';
import ruleswalkover from '../../../assets/ruleswalkover.png';

//import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { changeFormatDateTimeDB, checkSizeFile, exportLocaleRPC, getLimitUsersPackage, loadingShow, packageColor, participantsSolutions, removeEmojis, removeSpecialChars } from '../../../myfunctions';
import { ConnectWS, ConnectWSSendData } from '../../../ConnectWS';
import { useToasts } from 'react-toast-notifications';
import useAuth from '../../../hooks/useAuth';
import { Markup } from 'interweave';
import "react-datepicker/dist/react-datepicker.css";
import BuyCoffe from '../SinglePage/Other/BuyCoffe';
import BuyCoffeStart from '../SinglePage/Other/BuyCoffeStart';
import BuyAdsOff from '../SinglePage/Other/BuyAdsOff';
import GoogleSuggest from '../../../tools/google/GoogleSuggest';
import PackagesGTL from '../Dashboard/MyAccount/PackagesGTL';
import tgtl from '../../../assets/gtl.png';
import BuySupport from '../SinglePage/Other/BuySupport';
import BuyTestHotPay from '../SinglePage/Other/BuyTestHotPay';
import TurniejCharytatywny from '../SinglePage/Other/TurniejCharytatywny';
import SearchTournamentTG from '../SinglePage/Other/SearchTournamentTG';
import { addLocale } from 'primereact/api';
import ShowScoreDetailsView from '../Bracket/ShowScoreDetailsView';

import BuyUpgradeTournamentMembers from '../SinglePage/Other/BuyUpgradeTournamentMembers';
import MyImageLazy from '../../../tools/MyImageLazy';
import ReactPlayer from 'react-player';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import ChangeMyData from '../Dashboard/MyAccount/ChangeMyData';
import AddImgMediaUser from '../../../tools/AddImgMediaUser';
import InputCalendarAndTime from '../../../tools/InputCalendarAndTime';
import ChangeSubTournamentName from '../../../tools/ChangeSubTournamentName';
import Faq from '../SinglePage/Other/Faq';
import { confirmAlert } from 'react-confirm-alert';
import { AllowMembersSetScores } from '../../../tools/InfoText';
import LimitMebersTournament from '../../../tools/LimitMebersTournament';

function ModalInfo() {
    addLocale('pl', exportLocaleRPC());
    const { addToast } = useToasts();
    const authContext = useContext(AuthContext);
    const [openModal, setopenModal] = useState(false)
    const [auth, setAuth] = useAuth();// eslint-disable-line no-unused-vars
    const [openModalBody, setopenModalBody] = useState("")
    const [TournamentTypeAlgorithm, setTournamentTypeAlgorithm] = useState([]);
    const [TournamentTypePlay, setTournamentTypePlay] = useState([]);
    const [getUserTokenStatsV, setgetUserTokenStatsV] = useState(0);
    const [loadingToken, setloadingToken] = useState(true);
    const [activeIndex, setactiveIndex] = useState(0);
    const { width, height } = useWindowDimensions();// eslint-disable-line no-unused-vars
    const [valueScoreType, setvalueScoreType] = useState(2)
    const [imgUrlTG, setimgUrlTG] = useState(null);
 

    const [statusError, setstatusError] = useState({ show: false, message: null });
    let lictl = `Jeżeli uczestnik zostanie przypisany jednorazowo do dowolnego turnieju przy pomocy adresu e-mail zostanie wygenerowany unikalny identyfikator XXXXX zwany dalej <b>Numer TG</b>.<br/><br/>Zalety posiadania takiego numeru TG.
    <ul >
  <li>W każdych kolejnych rozgrywkach wystarczy, że uczestnik poda adres email lub numer TG, zostanie zidentyfikowany jako ten sam gracz.</li>
  <li>Zawodnik może posługiwać się swoim numerem TG na dowolnych rozgrywkach gdzie jest wykorzystywany Turniej Generator, dzięki temu będzie zbierał statystyki ze wszystkich turniejów, lig w których brał udział.</li>
  <li>Unikalny profil z zaawansowanymi statystykami.</li>
  </ul>`


    function delRuleRow(line) {
        if (line.member1_score === null && line.member2_score === null) {
            confirmAlert({
                title: 'Proszę potwierdzić',
                message: 'Czy chcesz skasować rekord z definicją punktacji dowolnej?, nię będzie można wprowadzać wyników inne niż zdefiniowane na tej liście!',
                buttons: [
                    {
                        label: 'Tak',
                        onClick: () => delRuleRowAcc(line)
                    },
                    {
                        label: 'Nie',
                        onClick: () => ''
                    }
                ]
            });
        } else {
            delRuleRowAcc(line)
        }


    }

    function delRuleRowAcc(line) {
        let array = [...form.pointsRule]; // make a separate copy of the array
        let index = array.indexOf(line)
        if (index !== -1) {
            array.splice(index, 1);
            if (array.length > 0) {
                array.forEach((row, i) => {
                    array[i] = { ...row, priority: i + 1 }
                })
            }
            setForm({ ...form, pointsRule: array })
        }
    }

    function addRowRule(e) {
        e.preventDefault();
        setstatusError({ show: false, message: null })
        let tmp = [...form.pointsRule]
        //sprawdzamy
        let mexit = 0





        if (pointsRuleTmp.member1_score === null || pointsRuleTmp.member1_score === "") {
            if (pointsRuleTmp.member2_score !== null && pointsRuleTmp.member2_score !== "") {
                mexit = 1
                setstatusError({ show: true, message: "Popraw wynik pojedynku dla Uczestnika 1!" })
            }
        }

        if (pointsRuleTmp.member2_score === null || pointsRuleTmp.member2_score === "") {
            if (pointsRuleTmp.member1_score !== null && pointsRuleTmp.member1_score !== "") {
                mexit = 1
                setstatusError({ show: true, message: "Popraw wynik pojedynku dla Uczestnika 2!" })
            }
        }




        if (pointsRuleTmp.winner_score === null || pointsRuleTmp.winner_score === "") {
            mexit = 1
            setstatusError({ show: true, message: "Wprowadź ilość punktów za wygraną" })


        }

        if (pointsRuleTmp.loser_score === null || pointsRuleTmp.loser_score === "") {
            mexit = 1
            setstatusError({ show: true, message: "Wprowadź ilość punktów za przegraną" })

        }

        if (pointsRuleTmp.draw_score === null || pointsRuleTmp.draw_score === "") {
            mexit = 1
            setstatusError({ show: true, message: "Wprowadź ilość punktów za remis" })

        }

        if ((pointsRuleTmp.member2_score === null || pointsRuleTmp.member2_score === "") && pointsRuleTmp.winner_score < 1) {
            mexit = 1
            setstatusError({ show: true, message: "Punkty za wygraną muszą być większe od 0!" })
        }

        // zabezpieczenie dla remisu
        if (pointsRuleTmp.member1_score !== null && pointsRuleTmp.member1_score !== "" && pointsRuleTmp.member1_score === pointsRuleTmp.member2_score) {
            if (pointsRuleTmp.winner_score > 0) {
                mexit = 1
                setstatusError({ show: true, message: "Przy remisie punkty za wygraną musza być 0!" })
            }
            if (pointsRuleTmp.loser_score > 0) {
                mexit = 1
                setstatusError({ show: true, message: "Przy remisie punkty za przegraną musza być 0!" })
            }
            if (pointsRuleTmp.draw_score < 1) {
                mexit = 1
                setstatusError({ show: true, message: "Przy remisie punkty za remis muszą być większe niż 0!" })
            }
        }

        // zabezpieczenie dla wyniku
        if (pointsRuleTmp.member1_score !== null && pointsRuleTmp.member1_score !== "" && pointsRuleTmp.member1_score !== pointsRuleTmp.member2_score) {
            if (pointsRuleTmp.draw_score > 0) {
                mexit = 1
                setstatusError({ show: true, message: "Przy wyniku wygrywającym, punkty za remis muszą być 0!" })
            }
            if (pointsRuleTmp.winner_score < 1) {
                mexit = 1
                setstatusError({ show: true, message: "Przy wyniku wygrywającym, punkty za wygraną muszą być większe niż 0!" })
            }

        }

        if (tmp.length > 0) {
            tmp.forEach((row) => {
                if ((row.member1_score === null && row.member2_score === null) && ((pointsRuleTmp.member1_score === null && pointsRuleTmp.member2_score === null) || (pointsRuleTmp.member1_score === "" && pointsRuleTmp.member2_score === ""))) {
                    mexit = 1
                    setstatusError({ show: true, message: "Taka pozycja jest już dodana!" })
                }
                if (((row.member1_score === pointsRuleTmp.member1_score && row.member2_score === pointsRuleTmp.member2_score) ||
                    (row.member2_score === pointsRuleTmp.member1_score && row.member1_score === pointsRuleTmp.member2_score)) && pointsRuleTmp.walkover === row.walkover) {
                    mexit = 1
                    setstatusError({ show: true, message: "Taka pozycja jest już dodana!!" })
                }
            })
        }

        if (mexit > 0) {

        } else {
            tmp.push({ draw_score: pointsRuleTmp.draw_score, loser_score: pointsRuleTmp.loser_score, winner_score: pointsRuleTmp.winner_score, member1_score: pointsRuleTmp.member1_score === "" ? null : pointsRuleTmp.member1_score, member2_score: pointsRuleTmp.member2_score === "" ? null : pointsRuleTmp.member2_score, walkover: pointsRuleTmp.walkover })
            tmp.sort((a, b) => (b.member1_score - a.member1_score))
            console.log(tmp)
            if (tmp.length > 0) {
                tmp.forEach((row, i) => {
                    tmp[i] = { ...row, priority: i + 1 }
                })
            }

            setForm({ ...form, pointsRule: tmp })
        }

    }

    function changeOrderRule(index, direction) {
        let array = [...form.pointsRule]; // make a separate copy of the array
        setForm({ ...form, pointsRule: reorderArrayRule({ oldIndex: index, newIndex: index + (direction === "UP" ? (-1) : 1) }, array) });
    }

    const reorderArrayRule = (event, originalArray) => {
        const movedItem = originalArray.find((item, index) => index === event.oldIndex);
        const remainingItems = originalArray.filter((item, index) => index !== event.oldIndex);

        const reorderedItems = [
            ...remainingItems.slice(0, event.newIndex),
            movedItem,
            ...remainingItems.slice(event.newIndex)
        ];
        if (reorderedItems.length > 0) {
            reorderedItems.forEach((row, i) => {
                reorderedItems[i] = { ...row, priority: i + 1 }
            })
        }
        return reorderedItems;
    }

    function checkRulesIsOK() {
        setstatusError({ show: false, message: null })
        //sprawdzamy  
        if (form.pointsRule.length > 0) {

            /*
            if (form.pointsRule[form.pointsRule.length - 1].member1_score !== null && form.pointsRule[form.pointsRule.length - 1].member1_score !== "") {
                setstatusError({ show: true, message: "Wynik pojedynku DOWOLNY powinien mieć najniższy priorytet, czyli być na koncu tabeli, kliknij strzałkę zeby to zmienić" })
                return false
            }
                */

            return true
        } else {
            setstatusError({ show: true, message: "Brak wpisanych wyników!" })
            return false
        }

    }

    const [pointsRuleTmp, setpointsRuleTmp] = useState({ draw_score: 0, loser_score: 0, winner_score: 2, member1_score: null, member2_score: null, walkover: false });
    const [form, setForm] = useState({
        ChangeDataInputValue: "",
        InputValue: "",
        InputValueNumber: "",
        InputValueEmail: "",
        InputValuePlace: "",
        BoolValue: "",
        InputHTML: "",
        InputKat: "",
        InputPhoto: "",
        SelectRow: "",
        selectRowAP: "",
        google_ads: "",
        mtype: "",
        videoData: [],
        packetType: 1,
        pointsRule: []
    });


    const [videoDataTmp, setvideoDataTmp] = useState({
        name: "",
        url: ""
    });

    function getUserTokenStats() {

        setloadingToken(true)
        ConnectWS("/generator/getUserTokenStats", authContext.token, {}, function (response, logout) {

            if (logout === 1) {

            } else if (response && response.status && Number(response.status) === 200) {
                setgetUserTokenStatsV(response.data)
            } else {

                if (logout === 101) {
                    addToast(response, { appearance: 'info' });
                } else if (logout === 102) {
                    addToast(response, { appearance: 'warning' });
                } else {
                    addToast(response, { appearance: 'error' });
                }
            }
            setloadingToken(false)


        });
    }

    const addVideoData = e => {
        e.preventDefault();
        let arrTmp = []
        if (form.videoData && form.videoData.length > 0) {
            arrTmp = form.videoData
        }
        arrTmp.push({ name: videoDataTmp.name, url: videoDataTmp.url })
        setForm({ ...form, videoData: arrTmp })

    }

    function removeTextToList(index) {
        let arrtmp = form.videoData !== null ? form.videoData : [];
        arrtmp.splice(index, 1)
        setForm({ ...form, videoData: arrtmp })
    }

    const [isloading, setisloading] = useState(false)

    const fileInputRef = useRef(null)

    const compressImage = async (file, { quality = 1, type = file.type }) => {
        // Get as image data
        const imageBitmap = await createImageBitmap(file);

        // Draw to canvas
        const canvas = document.createElement('canvas');
        canvas.width = imageBitmap.width;
        canvas.height = imageBitmap.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(imageBitmap, 0, 0);

        // Turn into Blob
        return await new Promise((resolve) =>
            canvas.toBlob(resolve, type, quality)
        );
    };

    const onImageChange = async (event) => {
        if (event.target.files && event.target.files[0]) {
            let imgtmp = event.target.files[0]
            let imgtmp1 = await compressImage(imgtmp, {
                // 0: is maximum compression
                // 1: is no compression
                quality: 0.5,
                // We want a JPEG file
                type: 'image/jpeg',
            })
            let imgtmp2 = await compressImage(imgtmp, {
                // 0: is maximum compression
                // 1: is no compression
                quality: 0.3,
                // We want a JPEG file
                type: 'image/jpeg',
            })

            if (checkSizeFile(imgtmp)) {
                setForm({ ...form, InputPhoto: URL.createObjectURL(imgtmp), mtype: "InputPhoto" })
            } else if (checkSizeFile(imgtmp1)) {
                addToast("Rozmiar przekracza " + Number(process.env.REACT_APP_IN_SIZEFILEKB) + " KB, zmieniam jakoś obrazka v1!", { appearance: 'info' });
                setForm({ ...form, InputPhoto: URL.createObjectURL(imgtmp1), mtype: "InputPhoto" })
            } else if (checkSizeFile(imgtmp2)) {
                addToast("Rozmiar przekracza " + Number(process.env.REACT_APP_IN_SIZEFILEKB) + " KB, zmieniam jakoś obrazka v2!", { appearance: 'info' });
                setForm({ ...form, InputPhoto: URL.createObjectURL(imgtmp2), mtype: "InputPhoto" })
            } else {
                closeOpenModal()
                addToast("Rozmiar pliku przekracza " + Number(process.env.REACT_APP_IN_SIZEFILEKB) + " KB", { appearance: 'error' });
                clearImageChange()
            }
        }
    }

    const clearImageChange = () => {

        setForm({ ...form, InputPhoto: null })
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }

    }

    function clearFrom() {
        setForm({ ChangeDataInputValue: "", pointsRule: [], packetType: 1, InputValue: "", InputValueNumber: "", InputValueEmail: "", InputValuePlace: "", BoolValue: "", InputHTML: "", InputKat: "", InputPhoto: "", SelectRow: "", selectRowAP: "", google_ads: "", mtype: "", videoData: [] })
    }

    async function saveDataDB() {
        //let json = {tournament_id: openModalBody.tournamentId}
        let json = { ...authContext.modalInfo.jsonBody }
        if (form.ChangeDataInputValue !== null && form.mtype === "datapicker") {
            json = { ...json, [openModalBody.dataSendName]: changeFormatDateTimeDB(form.ChangeDataInputValue) }
            try{
                if(new Date(json.start_date)<new Date(json.register_stop_date) && json.register_online===1){
                    addToast("Data konca zapisów nie może być większa niż data "+json.start_date+" rozpoczęcia turnieju! ", { appearance: 'warning' });
                    return
                }
            }catch(e){

            }
       
        } else if (form.InputValue !== null && form.mtype === "InputValue") {
            json = { ...json, [openModalBody.dataSendName]: (form.InputValue) }
        } else if (form.InputValuePlace !== null && form.mtype === "InputValuePlace") {
            json = { ...json, [openModalBody.dataSendName]: (JSON.stringify(form.InputValuePlace)) }
        } else if (form.BoolValue !== null && form.mtype === "BoolValue") {
            json = { ...json, [openModalBody.dataSendName]: (form.BoolValue) }
        } else if (form.BoolValue !== null && form.mtype === "externalSerwer") {
            json = { ...json, [openModalBody.dataSendName]: (form.BoolValue) }
        } else if (form.InputHTML !== null && form.mtype === "InputHTML") {
            json = { ...json, [openModalBody.dataSendName]: (form.InputHTML) }
        } else if (form.InputKat !== null && form.mtype === "InputKat") {
            json = { ...json, [openModalBody.dataSendName]: (form.InputKat) }
        } else if (form.SelectRow !== null && form.mtype === "SelectRow") {
            json = { ...json, [openModalBody.dataSendName]: (form.SelectRow) }
        } else if (form.selectRowAP !== null && form.mtype === "selectRowAP") {
            json = { ...json, [openModalBody.dataSendName]: (form.selectRowAP) }
        } else if (form.google_ads !== null && form.mtype === "google_ads") {
            json = { ...json, [openModalBody.dataSendName]: (form.google_ads) }
        } else if (form.video_data !== null && form.mtype === "video_data") {
            json = { ...json, [openModalBody.dataSendName]: (form.videoData) }
        } else if (form.InputValueNumber !== null && form.mtype === "InputValueNumber") {
            json = { ...json, [openModalBody.dataSendName]: (form.InputValueNumber) }
        } else if (form.InputValueEmail !== null && form.mtype === "InputValueEmail") {
            json = { ...json, [openModalBody.dataSendName]: (form.InputValueEmail) }
        } else if (form.packetType !== null && form.mtype === "packetType") {
            json = { ...json, [openModalBody.dataSendName]: (form.packetType) }
        } else if (form.pointsRule !== null && form.mtype === "pointsRule") {
            if (checkRulesIsOK()) {
                json = { ...json, [openModalBody.dataSendName]: (form.pointsRule) }
            } else {
                return
            }

        }

        if (authContext.modalInfo.activity_id > 0) {
            setisloading(true)
            ConnectWS("/activity/editActivity", authContext.token, json, function (response, logout) {
                if (logout === 1) {
                    addToast('Zaraz nastapi wylogowanie: ' + response.error, { appearance: 'error' });
                    setTimeout(() => {
                        setAuth(false);
                    }, 4000);

                } else if (response && response.status && Number(response.status) === 200) {
                    addToast(response.data.message, { appearance: 'success' });
                    clearFrom()
                    authContext.changeRefreshView(authContext.refreshView + 1)
                } else {
                    if (logout === 101) {
                        addToast(response, { appearance: 'info' });
                    } else if (logout === 102) {
                        addToast(response, { appearance: 'warning' });
                    } else {
                        addToast(response, { appearance: 'error' });
                    }
                    clearFrom()
                }
                setisloading(false)
                closeOpenModal()


            });
        }
        else if (form.InputKat !== "") {
            ConnectWS("/generator/addSubtournament", authContext.token, { tournament_id: openModalBody.jsonBody.tournament_id, subtournament_type: 'CUP_SIMPLE', subtournament_name: form.InputKat.trim() }, function (response, logout) {
                if (logout === 1) {
                    addToast('Zaraz nastapi wylogowanie: ' + response.error, { appearance: 'error' });
                    setTimeout(() => {
                        setAuth(false);
                    }, 4000);

                } else if (response && response.status && Number(response.status) === 200) {
                    addToast(response.data.message, { appearance: 'success' });
                    clearFrom()
                    authContext.changeRefreshView(authContext.refreshView + 1)
                } else {
                    if (logout === 101) {
                        addToast(response, { appearance: 'info' });
                    } else if (logout === 102) {
                        addToast(response, { appearance: 'warning' });
                    } else {
                        addToast(response, { appearance: 'error' });
                    }
                    clearFrom()
                }
                closeOpenModal()


            });

        } else if (form.InputPhoto !== "" || form.InputPhoto === null) {
            const formData = new FormData();

            let file = null
            if (form.InputPhoto === null || form.InputPhoto === "") {

            } else {

                await fetch(form.InputPhoto, file)
                    .then(res => res.blob())
                    .then(blob => {
                        file = new File([blob], "Zdjecie", { type: "image/png" })

                    })
            }
            let editPicture = form.InputPhoto === null ? 3 : 2
            formData.append('pictureData', file);
            formData.append('tournament_id', openModalBody.jsonBody.tournament_id);
            formData.append('editPicture', editPicture);


            ConnectWSSendData("/generator/editTournamentImg", authContext.token, formData, function (response, logout) {
                if (logout === 1) {
                    addToast('Zaraz nastapi wylogowanie: ' + response.error, { appearance: 'error' });
                    setTimeout(() => {
                        setAuth(false);
                    }, 4000);

                } else if (response && response.status && Number(response.status) === 200) {
                    addToast(response.data.message, { appearance: 'success' });
                    clearFrom()
                    authContext.changeRefreshView(authContext.refreshView + 1)
                } else {
                    if (logout === 101) {
                        addToast(response, { appearance: 'info' });
                    } else if (logout === 102) {
                        addToast(response, { appearance: 'warning' });
                    } else {
                        addToast(response, { appearance: 'error' });
                    }
                    clearFrom()
                }
                closeOpenModal()


            });
        } else {
            setisloading(true)
            ConnectWS("/generator/editTournament", authContext.token, json, function (response, logout) {
                if (logout === 1) {
                    addToast('Zaraz nastapi wylogowanie: ' + response.error, { appearance: 'error' });
                    setTimeout(() => {
                        setAuth(false);
                    }, 4000);

                } else if (response && response.status && Number(response.status) === 200) {
                    addToast(response.data.message, { appearance: 'success' });
                    clearFrom()
                    authContext.changeRefreshView(authContext.refreshView + 1)
                } else {
                    if (logout === 101) {
                        addToast(response, { appearance: 'info' });
                    } else if (logout === 102) {
                        addToast(response, { appearance: 'warning' });
                    } else {
                        addToast(response, { appearance: 'error' });
                    }
                    clearFrom()
                }
                setisloading(false)
                closeOpenModal()


            });
        }
    }


    function getAlgorithmTypes() {
        //setloading(true)
        ConnectWS("/generator/getAlgorithmTypes", null, {}, function (response, logout) {
            if (logout === 1) {
            } else if (response && response.status && Number(response.status) === 200) {

                let arr = []
                arr.length = 0
                response.data.forEach((data, i) => {
                    arr.push({ key: i, text: data.name, value: data.algorithm_id })
                    //dictemat.push({ key: i, text: data.Login, value: data.Login })
                })

                setTournamentTypeAlgorithm(arr);

            } else {
                if (logout === 101) {
                    addToast(response, { appearance: 'info' });
                } else if (logout === 102) {
                    addToast(response, { appearance: 'warning' });
                } else {
                    addToast(response, { appearance: 'error' });
                }
            }
            // setloading(false)
        });
    }

    function getTournamentTypePlay() {
        //setloading(true)
        ConnectWS("/generator/getPointsCalcSystemTypes", null, {}, function (response, logout) {
            if (logout === 1) {
            } else if (response && response.status && Number(response.status) === 200) {

                let arr = []
                arr.length = 0
                response.data.forEach((data, i) => {
                    arr.push({ key: i, text: data.system_name, value: data.points_calc_system_id })
                    //dictemat.push({ key: i, text: data.Login, value: data.Login })
                })

                setTournamentTypePlay(arr);

            } else {
                if (logout === 101) {
                    addToast(response, { appearance: 'info' });
                } else if (logout === 102) {
                    addToast(response, { appearance: 'warning' });
                } else {
                    addToast(response, { appearance: 'error' });
                }
            }
            // setloading(false)
        });
    }



    useEffect(() => {
        if (imgUrlTG) {
            setForm({ ...form, InputValue: imgUrlTG })
        }
        return () => { }; // use effect cleanup to set flag false, if unmounted
    }, [imgUrlTG])// eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        setimgUrlTG(null)

        if (Number(process.env.REACT_APP_API_DEBUG) === 1) {
            console.log("View: ModalInfo", authContext.modalInfo)
        }
        if (authContext.modalInfo && (authContext.modalInfo.nameModal === "lictl" || authContext.modalInfo.nameModal === "all")) {
            setopenModal(true)
            setopenModalBody(authContext.modalInfo && authContext.modalInfo.nameModal === "lictl" ? lictl : authContext.modalInfo.value)
        } else if (authContext.modalInfo && authContext.modalInfo.nameModal === "ChangeTurnament") {
            setopenModal(true)
            setopenModalBody(authContext.modalInfo)
            if (authContext.modalInfo.itype === "datapicker") {
                setForm({ ...form, ChangeDataInputValue: new Date(authContext.modalInfo.value), mtype: "datapicker" })
            } else if (authContext.modalInfo.itype === "checkbox") {
                setForm({ ...form, BoolValue: authContext.modalInfo.value, mtype: "BoolValue" })
            } else if (authContext.modalInfo.itype === "checkboxPakiet") {
                getUserTokenStats()
                setForm({ ...form, packetType: authContext.modalInfo.value, mtype: "packetType" })
            } else if (authContext.modalInfo.itype === "externalSerwer") {
                setForm({ ...form, BoolValue: 1, mtype: "externalSerwer" })
            } else if (authContext.modalInfo.itype === "input") {
                setForm({ ...form, InputValue: authContext.modalInfo.value, mtype: "InputValue" })
            } else if (authContext.modalInfo.itype === "InputNumber") {
                setForm({ ...form, InputValueNumber: authContext.modalInfo.value, mtype: "InputValueNumber" })
            } else if (authContext.modalInfo.itype === "InputMail") {
                setForm({ ...form, InputValueEmail: authContext.modalInfo.value, mtype: "InputValueEmail" })
            } else if (authContext.modalInfo.itype === "InputPlace") {
                setForm({ ...form, InputValuePlace: "", mtype: "InputValuePlace" })
            } else if (authContext.modalInfo.itype === "RichTextEditor") {
                setForm({ ...form, InputHTML: authContext.modalInfo.value, mtype: "InputHTML" })
            } else if (authContext.modalInfo.itype === "InputKat") {
                setForm({ ...form, InputKat: authContext.modalInfo.value, mtype: "InputKat" })
            } else if (authContext.modalInfo.itype === "photo") {
                setForm({ ...form, InputPhoto: authContext.modalInfo.value, mtype: "InputPhoto" })
            } else if (authContext.modalInfo.itype === "selectRow") {
                getTournamentTypePlay()
                setForm({ ...form, SelectRow: authContext.modalInfo.value, mtype: "SelectRow" })
            } else if (authContext.modalInfo.itype === "selectRowAP") {
                getAlgorithmTypes()
                setForm({ ...form, selectRowAP: authContext.modalInfo.value, mtype: "selectRowAP" })

            } else if (authContext.modalInfo.itype === "google_ads") {
                setForm({ ...form, google_ads: authContext.modalInfo.value, mtype: "google_ads" })
            } else if (authContext.modalInfo.itype === "video_data") {
                setForm({ ...form, videoData: authContext.modalInfo.value, mtype: "video_data" })
            } else if (authContext.modalInfo.itype === "pointsRule") {
                setForm({ ...form, pointsRule: authContext.modalInfo.value, mtype: "pointsRule" })
            }




        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "buyCoffe" || authContext.modalInfo.nameModal === "buyCoffeQuestions")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "RELO")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "ChangeMyData")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "ADDTS")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "VideoModal")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "MatchReport")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "GLICKO")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "limitMembers")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "PackagesGTL")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "ChangeSubTournamentName")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "SupportTournament")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "BuyTestHotPay")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "generateHotPayDataUpgradeTournamentMembersToLictl")) {
            setopenModal(true)
        }
        else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "TCharytatywny")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "SearchTournamentTG")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "WynikiSzczegolowe")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "ruauto")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "CUP_SIMPLE"
            || authContext.modalInfo.nameModal === "CUP_DOUBLE_ELIMINATION"
            || authContext.modalInfo.nameModal === "CUP_N_ELIMINATION_SIMPLE"
            || authContext.modalInfo.nameModal === "CUP_N_ELIMINATION_DOUBLE"
            || authContext.modalInfo.nameModal === "CUP_BRASIL"
            || authContext.modalInfo.nameModal === "CUP_N_PLACE"
            || authContext.modalInfo.nameModal === "GROUPS_CUP"
            || authContext.modalInfo.nameModal === "GROUP"
            || authContext.modalInfo.nameModal === "SWISS"
            || authContext.modalInfo.nameModal === "SWISS_CUP"
            || authContext.modalInfo.nameModal === "LEAGUE"
            || authContext.modalInfo.nameModal === "INDIVIDUAL"

        )) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "faq")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "globalViewValue")) {
            setopenModal(true)
        } else if (authContext.modalInfo && (authContext.modalInfo.nameModal === "AllowMembersSetScores")) {
            setopenModal(true)
        }



        return () => { }; // use effect cleanup to set flag false, if unmounted
    }, [authContext.modalInfo])// eslint-disable-line react-hooks/exhaustive-deps





    function closeOpenModal() {
        clearFrom()
        setopenModal(false)
        authContext.changeModalInfo(false)
    }



    function getInfoTournamentSystem(id) {

        if (id === "CUP_SIMPLE") {
            return <> <List ordered>
                <List.Item>Liczba uczestników jest potęgą dwójki (np. 8, 16, 32, itd.), w przypadku mniejszej ilości uczestników, brakujące pozycje zostaną uzupełnione o wolne losy.</List.Item>
                <List.Item>Drużyna lub zawodnik musi wygrać, aby przejść do kolejnej rundy, ale jeśli przegra, odpada z turnieju.</List.Item>
                <List.Item>W tym systemie rozgrywek wyłaniamy tylko <b>miejsca 1,2</b> kolejne miejsca to przedział drabinkowy na jakim odpadł dany uczestnik.</List.Item>
                <List.Item>Istnieje możliwość dodania pojedynku <b>o miejsce 3,4</b></List.Item>
            </List>
                <Message size='mini'>Jeżeli zostanie wybrany ten typ turnieju w Grupowo-Pucharowym dla turnieju pocieszenia, wówczas wszystkie powyższe miejsca to kontynuacja turnieju głownego.</Message></>
        } else if (id === "CUP_DOUBLE_ELIMINATION") {
            return <><List ordered>
                <List.Item>Liczba uczestników jest potęgą dwójki (np. 8, 16, 32, itd.), w przypadku mniejszej ilości uczestników, brakujące pozycje zostaną uzupełnione o wolne losy.</List.Item>
                <List.Item>Drużyna lub zawodnik musi wygrać, aby przejść do kolejnej rundy, ale jeśli przegra, przechodzi do nowej drabinki z jedna porażką (potocznie zwaną lewą stroną) ale jeśli przegra kolejny pojedynek (drugi), odpada z turnieju.</List.Item>
                <List.Item>Uczestnicy bez porażki walczą o <b>miejsca 1,2</b></List.Item>
                <List.Item>Uczestnicy z jedną porażką walczą o <b>miejsca 3,4</b></List.Item>
            </List>
                <Message size='mini'>Jeżeli zostanie wybrany ten typ turnieju w Grupowo-Pucharowym dla turnieju pocieszenia, wówczas wszystkie powyższe miejsca to kontynuacja turnieju głownego.</Message></>
        } else if (id === "CUP_N_ELIMINATION_SIMPLE") {
            return <>  <List ordered>
                <List.Item>Liczba uczestników jest potęgą dwójki (np. 8, 16, 32, itd.), w przypadku mniejszej ilości uczestników, brakujące pozycje zostaną uzupełnione o wolne losy.</List.Item>
                <List.Item>Drużyna lub zawodnik musi wygrać, aby przejść do kolejnej rundy, ale jeśli przegra, gra o konkretne miejsce z danego przedziału</List.Item>
                <List.Item>W tym systemie rozgrywek uczestnik bez porażki gra o <b>miejsca 1,2</b></List.Item>
            </List>
                <Message size='mini'>Jeżeli zostanie wybrany ten typ turnieju w Grupowo-Pucharowym dla turnieju pocieszenia, wówczas wszystkie powyższe miejsca to kontynuacja turnieju głownego.</Message></>
        } else if (id === "CUP_N_ELIMINATION_DOUBLE") {
            return <> <List ordered>
                <List.Item>Liczba uczestników jest potęgą dwójki (np. 8, 16, 32, itd.), w przypadku mniejszej ilości uczestników, brakujące pozycje zostaną uzupełnione o wolne losy.</List.Item>
                <List.Item>Drużyna lub zawodnik musi wygrać, aby przejść do kolejnej rundy, ale jeśli przegra, przechodzi do nowej drabinki z jedna porażką (potocznie zwaną lewą stroną)</List.Item>
                <List.Item>Uczestnicy bez porażki walczą o <b>miejsca 1,2</b></List.Item>
                <List.Item>Uczestnicy z jedną porażką walczą o <b>miejsca 3,4</b></List.Item>
                <List.Item>Pozostali (uczestnicy z min. dwoma porażkami) walczą o kolejne miejsca</List.Item>
            </List>
                <Message size='mini'>Jeżeli zostanie wybrany ten typ turnieju w Grupowo-Pucharowym dla turnieju pocieszenia, wówczas wszystkie powyższe miejsca to kontynuacja turnieju głownego.</Message></>
        } else if (id === "CUP_BRASIL") {
            return <> <List ordered>
                <List.Item>Liczba uczestników jest potęgą dwójki (np. 8, 16, 32, itd.), w przypadku mniejszej ilości uczestników, brakujące pozycje zostaną uzupełnione o wolne losy.</List.Item>
                <List.Item>Drużyna lub zawodnik musi wygrać, aby przejść do kolejnej rundy, ale jeśli przegra, przechodzi do nowej drabinki z jedna porażką (potocznie zwaną lewą stroną)</List.Item>
                <List.Item>Finalista bez porażki czeka na Uczestnika z "Turnieju z jedną porażką", co powoduje że uczestnik z jedną porażką może wygrać turniej!</List.Item>
            </List>
                <Message size='mini'>Jeżeli zostanie wybrany ten typ turnieju w Grupowo-Pucharowym dla turnieju pocieszenia, wówczas wszystkie powyższe miejsca to kontynuacja turnieju głownego.</Message></>
        } else if (id === "CUP_N_PLACE") {
            return <List ordered>
                <List.Item>Zostana utworzone pary meczowe o konkretne miejsce np 1-2,3-4,5-6 itd</List.Item>
                <List.Item>Jeżeli ten typ turnieju jest wybrany jako pocieszenia (Turnieju główny np. ma 8 uczestników) to są to kolejne mecze np 9-10,11-12 itd</List.Item>
            </List>
        } else if (id === "GROUPS_CUP") {
            return <div>
                <h3>FAZA GRUPOWA</h3>
                Na początku turnieju wszyscy uczestnicy są podzieleni na grupy.<br />
                Zazwyczaj liczba grup zależy od liczby uczestników w turnieju.<br />
                Każdy uczestnik gra ze wszystkimi pozostałymi uczestnikami w swojej grupie.<br />
                Punkty są przyznawane w zależności od konfiguracji <b>Punktacja w fazie grupowej</b><br />
                <h3>FAZA PUCHAROWA</h3>
                Organizator ma do wyboru:
                <List ordered>
                    <List.Item><b>Turniej Pucharowy Główny:</b> np miejsce 1,2 z danej grupy.</List.Item>
                    <List.Item><b>Turniej Pucharowy Główny:</b> np miejsce 1,2 z danej grupy + <b>Turniej Pucharowy Pocieszenia:</b> np miejsce 3,4 z danej grupy.</List.Item>
                </List>
            </div>
        } else if (id === "GROUP") {
            return <div>
                Turniej "każdy z każdym", nazywany również round-robin, to format turnieju,
                w którym każda drużyna lub zawodnik rywalizuje ze wszystkimi pozostałymi uczestnikami turnieju.
                Jest to jeden z najstarszych i najbardziej sprawiedliwych formatów, ponieważ każdy ma szansę zmierzyć się z każdym,
                eliminując przypadkowość w wyborze przeciwników.</div>
        } else if (id === "SWISS") {
            return <div>
                System szwajcarski jest sposobem organizacji turniejów, który umożliwia rywalizację uczestników przez określenie liczby rund np 4.
                <br />Oto jak działa ten system:
                <List ordered>
                    <List.Item><b>Rundy:</b> Turniej rozpoczyna się np od 4 rund, w zależności od liczby uczestników i preferencji organizatorów.
                        W każdej rundzie uczestnicy są przydzielani do meczów na podstawie ich dotychczasowych wyników.
                        Na przykład, w pierwszej rundzie mogą zostać przydzieleni losowo, a w kolejnych rundach zostają
                        rozstawieni na podstawie swoich wyników.</List.Item>
                    <List.Item><b>Parowanie uczestników:</b> W każdej rundzie uczestnicy są parowani w taki sposób, aby starali się grać z innymi uczestnikami
                        o zbliżonym wyniku do swojego. Na przykład, uczestnicy z podobnym wynikiem mogą zostać zestawieni ze sobą,
                        aby zapewnić jak najbardziej wyrównane i interesujące mecze.</List.Item>
                    <List.Item><b>Punktacja:</b> Po każdej rundzie uczestnicy otrzymują punkty w zależności od wyniku ich meczu.
                        Zazwyczaj jest to 1 punkt za każdy wygrany np set a pojedynek kończy się np po 4 setach.</List.Item>
                    <List.Item><b>Kolejne rundy:</b> Proces parowania i gry kolejnych rund kontynuuje się aż do zakończenia turnieju.
                        Liczba rund może być stała lub zależeć od ustaleń organizatorów i czasu, który jest dostępny na przeprowadzenie turnieju.</List.Item>
                    <List.Item><b>Determinacja Zwycięzcy:</b> Po zakończeniu wszystkich rund, zwycięzcą turnieju zostaje uczestnik z największą liczbą punktów.</List.Item>
                </List>
            </div>
        } else if (id === "SWISS_CUP") {
            return <div>
                System szwajcarski jest sposobem organizacji turniejów, który umożliwia rywalizację uczestników przez określenie liczby rund np 4.
                <br />Oto jak działa ten system:
                <List ordered>
                    <List.Item><b>Rundy:</b> Turniej rozpoczyna się np od 4 rund, w zależności od liczby uczestników i preferencji organizatorów.
                        W każdej rundzie uczestnicy są przydzielani do meczów na podstawie ich dotychczasowych wyników.
                        Na przykład, w pierwszej rundzie mogą zostać przydzieleni losowo, a w kolejnych rundach zostają
                        rozstawieni na podstawie swoich wyników.</List.Item>
                    <List.Item><b>Parowanie uczestników:</b> W każdej rundzie uczestnicy są parowani w taki sposób, aby starali się grać z innymi uczestnikami
                        o zbliżonym wyniku do swojego. Na przykład, uczestnicy z podobnym wynikiem mogą zostać zestawieni ze sobą,
                        aby zapewnić jak najbardziej wyrównane i interesujące mecze.</List.Item>
                    <List.Item><b>Punktacja:</b> Po każdej rundzie uczestnicy otrzymują punkty w zależności od wyniku ich meczu.
                        Zazwyczaj jest to 1 punkt za każdy wygrany np set a pojedynek kończy się np po 4 setach.</List.Item>
                    <List.Item><b>Kolejne rundy:</b> Proces parowania i gry kolejnych rund kontynuuje się aż do zakończenia turnieju.
                        Liczba rund może być stała lub zależeć od ustaleń organizatorów i czasu, który jest dostępny na przeprowadzenie turnieju.</List.Item>
                    <List.Item><b>Determinacja Zwycięzcy:</b> Po zakończeniu wszystkich rund, zwycięzcą turnieju zostaje uczestnik z największą liczbą punktów.</List.Item>
                    <h3>FAZA PUCHAROWA</h3>

                </List>
                Organizator ma do wyboru:
                <List ordered>
                    <List.Item><b>Turniej Pucharowy Główny:</b> np miejsce 1,2</List.Item>
                    <List.Item><b>Turniej Pucharowy Główny:</b> np miejsce 1,2 + <b>Turniej Pucharowy Pocieszenia:</b> np miejsce 3,4.</List.Item>
                </List>
            </div>
        } else if (id === "LEAGUE") {
            return <div>
                Rozgrywki ligowe to jedna z najbardziej popularnych form organizacji zawodów sportowych.<br />
                Oto jak działają rozgrywki ligowe:
                <List ordered>
                    <List.Item><b>Format:</b> Rozgrywki ligowe mogą być rozgrywane w formie jednorundowej, dwurundowej (rewanż).
                        W jednorundowym systemie każdy uczestnik spotyka się z każdym raz.
                        W dwurundowym systemie każdy uczestnik spotyka się z każdym dwa razy.
                    </List.Item>
                    <List.Item><b>Punktacja:</b> Punkty są przyznawane w zależności od konfiguracji <b>Punktacja w fazie grupowej</b> Punkty te są sumowane na przestrzeni całego sezonu. </List.Item>
                    <List.Item><b>Tabela Ligowa:</b> Na podstawie zdobytych punktów tworzona jest tabela ligowa,
                        która odzwierciedla aktualne położenie każdego uczestnika w lidze. Uczestnicy są zazwyczaj klasyfikowane na podstawie liczby punktów, a w przypadku równej liczby punktów decydują różne kryteria, takie jak bezpośrednie pojedynki uczestników z tą samą ilością punktów, stosunek pkt.
                    </List.Item>
                    <List.Item><b>Mistrzostwo i Spadki</b> Istnieje możliwość zdefiniowana ilości uczestników do spadków oraz awansów.</List.Item>
                </List>
            </div>
        } else if (id === "INDIVIDUAL") {
            return <div>
            <Header as="h1" textAlign="center">
              System Turniejowy z Oceną Sędziowską
            </Header>
      
          
              
              <p>
                System turniejowy przeznaczony dla dyscyplin ocenianych przez sędziów, takich jak 
                <strong> karate (kata), gimnastyka, łyżwiarstwo figurowe</strong>. Zawodnicy przechodzą przez kolejne rundy, 
                a ich występy są oceniane na podstawie średniej po odrzuceniu skrajnych ocen.
              </p>
         
      
          
              <Header as="h2">2. Struktura turnieju</Header>
      
              <Header as="h3">I. Eliminacje</Header>
              <List bulleted>
                <List.Item>Zawodnicy otrzymują oceny od 6 sędziów.</List.Item>
                <List.Item>Najwyższa i najniższa ocena są odrzucane.</List.Item>
                <List.Item>Średnia z pozostałych ocen decyduje o wyniku.</List.Item>
                <List.Item>Najlepsi przechodzą do półfinału.</List.Item>
              </List>
      
              <Header as="h3">II. Półfinał</Header>
              <List bulleted>
                <List.Item>Ponowna rywalizacja najlepszych zawodników.</List.Item>
                <List.Item>Oceny przyznawane według tych samych zasad.</List.Item>
                <List.Item>Do finału awansuje najlepsza dwójka.</List.Item>
              </List>
      
              <Header as="h3">III. Finał</Header>
              <List bulleted>
                <List.Item>Finaliści prezentują swoje najlepsze układy.</List.Item>
                <List.Item>Ostateczna ocena na tych samych zasadach.</List.Item>
                <List.Item>Zawodnik z najwyższą średnią wygrywa.</List.Item>
              </List>
           
      
          
              <Header as="h2">3. Kluczowe zasady systemu</Header>
              <List bulleted>
                <List.Item>✅ Oceny od 6 sędziów eliminują subiektywne błędy.</List.Item>
                <List.Item>✅ Odrzucenie najwyższej i najniższej oceny zwiększa sprawiedliwość.</List.Item>
                <List.Item>✅ Średnia z pozostałych ocen decyduje o wyniku.</List.Item>
                <List.Item>✅ Brak sumowania punktów z rund – każda runda jest niezależna.</List.Item>
              </List>
           
      
          
              <Header as="h2">4. Zalety systemu</Header>
              <List bulleted>
                <List.Item>✔ Transparentność – jasne zasady oceny.</List.Item>
                <List.Item>✔ Bezpieczeństwo wyników – eliminacja skrajnych ocen.</List.Item>
                <List.Item>✔ Dynamiczna rywalizacja – każda runda daje szansę na poprawę wyniku.</List.Item>
              </List>
          
      
         
              <Header as="h2">5. Kiedy warto wybrać ten system?</Header>
              <List bulleted>
                <List.Item>✅ Gdy liczy się jakość wykonania, a nie tylko wynik końcowy.</List.Item>
                <List.Item>✅ Gdy chcesz zapewnić eliminację najsłabszych zawodników.</List.Item>
                <List.Item>✅ Gdy turniej opiera się na subiektywnej ocenie techniki i stylu.</List.Item>
              </List>
          
              <Header as="h2">6. Warianty systemu</Header>
              <List bulleted>
                <List.Item>🔹 Możliwość zmiany liczby sędziów (np. 5 lub 7).</List.Item>
                <List.Item>🔹 Regulowanie liczby eliminowanych zawodników na rundę.</List.Item>
                <List.Item>🔹 Opcjonalne sumowanie wyników z poprzednich rund.</List.Item>
              </List>
           
          </div>
        }

    }


    return (
        <>
            <Modal
                closeIcon={authContext.modalInfo && authContext.modalInfo.viewClickOff ? false : true}
                size='large'
                centered={width < 900 ? false : true}
                onClose={() => authContext.modalInfo && authContext.modalInfo.viewClickOff ? "" : closeOpenModal()}
                onOpen={() => setopenModal(true)}
                open={openModal}

            >

                {authContext.modalInfo && authContext.modalInfo.nameModal === "ChangeTurnament" ?
                    <>
                        <Modal.Header>
                            <Grid stackable>
                                <Grid.Row>
                                    <Grid.Column width={12} verticalAlign="middle">
                                        <Header as='h2' textAlign='center'>
                                            <Icon name='edit' color="red" />
                                            <Header.Content>{openModalBody ? openModalBody.name : ""}</Header.Content>
                                        </Header>
                                    </Grid.Column>
                                    <Grid.Column width={4} textAlign="right" only='large screen'>
                                        <Image alt="logo" floated='right'  style={{maxWidth:200}} centered src={LogoTeamLigaGenerator} />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>

                        </Modal.Header>
                        <Modal.Content className='modalBGcolor'>

                            {openModalBody && openModalBody.itype === "datapicker" ?
                                <Form>
                                    <Form.Group >
                                        <Form.Field>
                                            <label>{openModalBody ? openModalBody.name : ""}</label>
                                            {/* 
                                            <DatePicker
                                                locale="pl"
                                                selected={form.ChangeDataInputValue}
                                                onChange={(date) => setForm({ ...form, ChangeDataInputValue: date })}
                                                timeInputLabel="Godzina:"
                                                dateFormat="yyyy-MM-dd HH:mm "
                                                showTimeInput

                                                showPopperArrow={false}
                                            />
                                            */}
                                            <InputCalendarAndTime form={form} setForm={setForm} inputValue={"ChangeDataInputValue"} />
                                        </Form.Field>
                                        {/* <SemanticDatepicker clearIcon={false} clearOnSameDateClick={false} onChange={(e, data) => setForm({ ...form, ChangeDataInputValue: data.value })} value={form.ChangeDataInputValue} locale="pl-PL" label={openModalBody ? openModalBody.name : ""} /> */}

                                    </Form.Group>
                                    <Button fluid color="green" loading={isloading} disabled={isloading} onClick={() => saveDataDB()}>ZAPISZ</Button>
                                </Form>
                                : ''
                            }
                            {openModalBody && openModalBody.itype === "checkbox" ?
                                <>

                                    <Message  >Proszę potwierdzić {authContext.modalInfo.activity_id > 0 ? "" : form.BoolValue === 1 || form.BoolValue === true ? " włączenie " : " wyłączenie "} </Message>
                                    <Button fluid color="green" loading={isloading} disabled={isloading} onClick={() => saveDataDB()}>ZAPISZ</Button>
                                </>
                                : ''
                            }
                            {openModalBody && openModalBody.itype === "externalSerwer" ?
                                <>

                                    <Message  >Proszę potwierdzić {form.BoolValue === 1 || form.BoolValue === true ? " włączenie " : " wyłączenie "} </Message>
                                    <Button fluid color="green" loading={isloading} disabled={isloading} onClick={() => saveDataDB()}>ZAPISZ</Button>
                                </>
                                : ''
                            }
                            {openModalBody && openModalBody.itype === "RichTextEditor" ?
                                <>
                                    <Message negative={authContext.modalInfo.value === "" ? true : false} >{authContext.modalInfo.value === "" ? <><b>WAŻNE!</b> czy chcesz skasować całą zawartość opisu?</> : "Proszę potwierdzić zmianę opisu "}</Message>
                                    <Button fluid color={authContext.modalInfo.value === "" ? "red" : "green"} loading={isloading} disabled={isloading} onClick={() => saveDataDB()}>{authContext.modalInfo.value === "" ? "SKASUJ" : "ZAPISZ"}</Button>
                                </>
                                : ''
                            }
                            {openModalBody && openModalBody.itype === "checkboxPakiet" ?
                                loadingToken ? loadingShow() :
                                    <>
                                        <Card.Group centered style={{ margin: 2 }}>
                                            {authContext.modalInfo.value === 0 ?
                                                <Card color={form.packetType === 1 ? 'green' : "grey"} className={form.packetType === 1 ? 'colorSegmentCardDarkSukcesy1' : "colorSegmentCardDarkSukcesy0"}>
                                                    <Card.Content >
                                                        <Card.Header style={{ marginBottom: 10 }}> {packageColor(2)} PAKIET SREBRNY</Card.Header>
                                                        <Card.Meta style={{ fontSize: 14, lineHeight: 1.1, marginBottom: 10 }}> Wszystkie informacje na temat pakietów są w zakładce "MOJE KONTO - PAKIETY"</Card.Meta>
                                                        <Container textAlign='center' style={{ fontSize: 12 }}><b>LIMIT UCZESTNIKÓW - {getLimitUsersPackage(1)} (per kategoria)</b> <Icon className='cursorPointer' name="question circle" onClick={() => authContext.changeModalInfo({ nameModal: "PackagesGTL", name: "Pakiety - Cennik", value: "" })} />
                                                            <Divider className='mp3' />

                                                            <Checkbox onChange={(e, data) => setForm({ ...form, packetType: 1 })} disabled={getUserTokenStatsV && getUserTokenStatsV.currentTokensAmount < 1 ? true : false} checked={form.packetType === 1 ? true : false} label={getUserTokenStatsV && getUserTokenStatsV.currentTokensAmount < 1 ? "BRAK TOKENTÓW!" : "WYBIERAM"} />
                                                        </Container>
                                                    </Card.Content>
                                                    <Card.Content extra>

                                                    </Card.Content>
                                                    <Label attached='bottom'>ZOSTANIE POBRANE: 1 GTL</Label>
                                                </Card>
                                                : ""}
                                            <Card color={form.packetType === 2 ? 'green' : "grey"} className={form.packetType === 2 ? 'colorSegmentCardDarkSukcesy1' : "colorSegmentCardDarkSukcesy0"}>
                                                <Card.Content >
                                                    <Card.Header style={{ marginBottom: 10 }}> {packageColor(3)} PAKIET ZŁOTY</Card.Header>
                                                    <Card.Meta style={{ fontSize: 14, lineHeight: 1.1, marginBottom: 10 }}> Wszystkie informacje na temat pakietów są w zakładce "MOJE KONTO - PAKIETY"</Card.Meta>
                                                    <Container textAlign='center' style={{ fontSize: 12 }}><b>LIMIT UCZESTNIKÓW - BRAK</b> <Icon className='cursorPointer' name="question circle" onClick={() => authContext.changeModalInfo({ nameModal: "PackagesGTL", name: "Pakiety - Cennik", value: "" })} />
                                                        <Divider className='mp3' />
                                                        <Checkbox onChange={(e, data) => setForm({ ...form, packetType: 2 })} checked={form.packetType === 2 ? true : false} disabled={getUserTokenStatsV && getUserTokenStatsV.currentTokensAmount < (authContext.modalInfo.value === 0 ? 2 : 1) ? true : false} label={getUserTokenStatsV && getUserTokenStatsV.currentTokensAmount < (authContext.modalInfo.value === 0 ? 2 : 1) ? "BRAK TOKENTÓW!" : "WYBIERAM"} />
                                                    </Container>
                                                </Card.Content>
                                                <Card.Content extra>

                                                </Card.Content>
                                                <Label attached='bottom'>ZOSTANIE POBRANE: {authContext.modalInfo.value === 0 ? 2 : 1} GTL</Label>
                                            </Card>
                                        </Card.Group>
                                        <Divider />
                                        <Card.Group centered style={{ margin: 2 }}>
                                            <Card className='colorSegmentCardDarkSukcesy0'>

                                                <Card.Content >
                                                    <Image
                                                        alt="logo"
                                                        style={{ width: 70 }}
                                                        floated='right'
                                                        src={tgtl}
                                                    />
                                                    <Card.Header>TOKEN-GTL</Card.Header>
                                                    <Card.Meta style={{ fontSize: 14, lineHeight: 1.1 }}> Poniżej znajduje się liczba Twoich tokentów</Card.Meta>

                                                </Card.Content>
                                                <Card.Content extra>

                                                </Card.Content>
                                                <Label attached='bottom'>POSIADASZ: <span style={{ fontSize: 18, color: getUserTokenStatsV && getUserTokenStatsV.currentTokensAmount > 1 ? "green" : getUserTokenStatsV && getUserTokenStatsV.currentTokensAmount > 0 ? "orange" : "red" }}>{getUserTokenStatsV ? getUserTokenStatsV.currentTokensAmount : "?"}</span> GTL</Label>
                                            </Card>
                                        </Card.Group>
                                        <Button fluid loading={isloading} disabled={isloading || (authContext.modalInfo.value === form.packetType)} onClick={() => saveDataDB()}>ZAAKCEPTUJ</Button>
                                    </>
                                : ''
                            }
                            {openModalBody && openModalBody.itype === "input" ?
                                <>
                                    <Form>
                                        <Form.Group widths='equal'>
                                            {imgUrlTG && imgUrlTG !== "" ? <MyImageLazy openView={true} maxHeight={100} src={imgUrlTG} /> : ""}
                                            <Form.Field
                                                control={Input}
                                                required
                                                label={openModalBody ? openModalBody.name : ""}
                                                value={form.InputValue}
                                                onChange={(e, data) => openModalBody.dataSendName === "url" || openModalBody.dataSendName === "img_file" || openModalBody.dataSendName === "img_url" ? setForm({ ...form, InputValue: ((data.value)) }) : setForm({ ...form, InputValue: removeSpecialChars(removeEmojis(data.value)) })}
                                            />
                                            {openModalBody.dataSendName === "img_file" || openModalBody.dataSendName === "img_url" ? <AddImgMediaUser imgUrlTG={imgUrlTG} setimgUrlTG={setimgUrlTG} /> : ""}

                                        </Form.Group>
                                        <Button fluid color="green" loading={isloading} disabled={isloading} onClick={() => saveDataDB()}>ZAPISZ</Button>
                                    </Form>
                                </>
                                : ''
                            }
                            {openModalBody && openModalBody.itype === "InputNumber" ?
                                <>
                                    <Form>
                                        <Form.Group widths='equal'>
                                            <Form.Field
                                                control={Input}
                                                required
                                                type='number'
                                                label={openModalBody ? openModalBody.name : ""}
                                                value={form.InputValueNumber}
                                                onChange={(e, data) => setForm({ ...form, InputValueNumber: data.value })}
                                            />

                                        </Form.Group>
                                        <Button fluid color="green" loading={isloading} disabled={isloading} onClick={() => saveDataDB()}>ZAPISZ</Button>
                                    </Form>
                                </>
                                : ''
                            }

                            {openModalBody && openModalBody.itype === "InputMail" ?
                                <>
                                    <Form onSubmit={saveDataDB}>
                                        <Form.Group widths='equal'>
                                            <Form.Field
                                                control={Input}
                                                required
                                                type='email'
                                                label={openModalBody ? openModalBody.name : ""}
                                                value={form.InputValueEmail}
                                                onChange={(e, data) => setForm({ ...form, InputValueEmail: data.value })}
                                            />

                                        </Form.Group>
                                        <Button fluid color="green" loading={isloading} disabled={isloading} >ZAPISZ</Button>
                                    </Form>
                                </>
                                : ''
                            }

                            {openModalBody && openModalBody.itype === "InputPlace" ?
                                <>

                                    <Form onSubmit={saveDataDB}>
                                        <GoogleSuggest form={form} setForm={setForm} valueIn={form.InputValuePlace} />
                                        <br />

                                        <Button fluid color="green" loading={isloading} disabled={isloading || form.InputValuePlace === ""} >ZAPISZ</Button>
                                    </Form>
                                </>
                                : ''
                            }
                            {openModalBody && openModalBody.itype === "selectRow" ?
                                <>

                                    <Form>
                                        <Form.Group widths='equal'>
                                            <Form.Field
                                                control={Select} selectOnBlur={false}
                                                options={TournamentTypePlay}
                                                value={form.SelectRow}
                                                onChange={(e, data) => setForm({ ...form, SelectRow: data.value })}
                                                label='Rodzaj sportu - rozgrywanego turnieju'
                                                search
                                                placeholder='Proszę wybrać...'

                                            />


                                        </Form.Group>

                                        <Button fluid color="green" loading={isloading} disabled={isloading} onClick={() => saveDataDB()}>ZAPISZ</Button>
                                    </Form>
                                </>
                                : ''
                            }
                            {openModalBody && openModalBody.itype === "pointsRule" && form.pointsRule ?
                                <>

                                    <Message info size='mini'>
                                        <Message.Header>Informacja</Message.Header>
                                        <Message.List>
                                            <Message.Item>Wynik pojedynku jako <b>DOWOLNY</b> może być tylko raz</Message.Item>
                                            <Message.Item>Wynik pojedynku jako <b>DOWOLNY</b> musi mieć ustawiony najniższy (największa wartość np 2,3 itd) priorytet</Message.Item>
                                            <Message.Item>Wprowadzony wynik musi mieć wyższy priorytet niż wynik <b>DOWOLNY</b></Message.Item>
                                        </Message.List>
                                        <Accordion>
                                            <Accordion.Title
                                                active={activeIndex === 1}
                                                index={0}
                                                onClick={(e, titleProps) => setactiveIndex(titleProps.active ? 0 : 1)}
                                            >
                                                <Icon name='dropdown' />
                                                Pokaż przykład jak utworzyć punktację np dla siatkówki
                                            </Accordion.Title>
                                            <Accordion.Content active={activeIndex === 1}>
                                                <Image src={rulesvolleyball} style={{ width: 800 }} alt="logo" />
                                            </Accordion.Content>
                                            <Accordion.Title
                                                active={activeIndex === 2}
                                                index={0}
                                                onClick={(e, titleProps) => setactiveIndex(titleProps.active ? 0 : 2)}
                                            >
                                                <Icon name='dropdown' />
                                                Pokaż przykład jak utworzyć punktację z walkowerem
                                            </Accordion.Title>
                                            <Accordion.Content active={activeIndex === 2}>
                                                <Image src={ruleswalkover} style={{ width: 800 }} alt="logo" />
                                            </Accordion.Content>
                                        </Accordion>

                                    </Message>
                                    <Form style={{ marginBottom: 10 }}>

                                        <Form.Field>
                                            <Checkbox
                                                radio
                                                label='DOWOLNY WYNIK'
                                                name='checkboxRadioGroup'
                                                value={1}
                                                checked={valueScoreType === 1}
                                                onChange={(e, data) => {
                                                    setvalueScoreType(data.value)
                                                    setpointsRuleTmp({ ...pointsRuleTmp, member1_score: "", member2_score: "" })
                                                }
                                                }
                                            />

                                            <Checkbox
                                                style={{ marginLeft: 10 }}
                                                radio
                                                label='KONKRETNY WYNIK'
                                                name='checkboxRadioGroup'
                                                value={2}
                                                checked={valueScoreType === 2}
                                                onChange={(e, data) => setvalueScoreType(data.value)}
                                            />
                                        </Form.Field>
                                    </Form>
                                    <Form size='mini' onSubmit={addRowRule}>
                                        <Form.Group widths='equal'>
                                            <Form.Field
                                                control={Input}
                                                min="-5"
                                                max="1000"
                                                type='number'
                                                required={valueScoreType === 1 ? false : true}
                                                value={pointsRuleTmp.member1_score}
                                                disabled={valueScoreType === 1 ? true : false}
                                                onChange={(e, data) => {
                                                    setpointsRuleTmp({ ...pointsRuleTmp, member1_score: data.value.length > 0 ? Number(data.value) : data.value })
                                                }}
                                                label='Wynik Uczestnik 1'

                                            />
                                            <Form.Field
                                                control={Input}
                                                min="-5"
                                                max="1000"
                                                type='number'
                                                required={valueScoreType === 1 ? false : true}
                                                disabled={valueScoreType === 1 ? true : false}
                                                value={pointsRuleTmp.member2_score}
                                                onChange={(e, data) => {
                                                    setpointsRuleTmp({ ...pointsRuleTmp, member2_score: data.value.length > 0 ? Number(data.value) : data.value })
                                                }}
                                                label='Wynik Uczestnik 2'

                                            />
                                            <Form.Field
                                                control={Input}
                                                min="-5"
                                                max="10"
                                                type='number'
                                                required={true}
                                                value={pointsRuleTmp.winner_score}
                                                onChange={(e, data) => {
                                                    setpointsRuleTmp({ ...pointsRuleTmp, winner_score: data.value.length > 0 ? Number(data.value) : data.value })
                                                }}
                                                label='Pkt za wygraną'

                                            />
                                            <Form.Field
                                                control={Input}
                                                min="-5"
                                                max="10"
                                                type='number'
                                                required={true}
                                                value={pointsRuleTmp.draw_score}
                                                onChange={(e, data) => {
                                                    setpointsRuleTmp({ ...pointsRuleTmp, draw_score: data.value.length > 0 ? Number(data.value) : data.value })
                                                }}

                                                label='Pkt za remis'

                                            />
                                            <Form.Field
                                                control={Input}
                                                min="-5"
                                                max="10"
                                                type='number'
                                                required={true}
                                                value={pointsRuleTmp.loser_score}
                                                onChange={(e, data) => {
                                                    setpointsRuleTmp({ ...pointsRuleTmp, loser_score: data.value.length > 0 ? Number(data.value) : data.value })
                                                }}

                                                label='Pkt za przegraną'

                                            />
                                            <Form.Field
                                                control={Select}
                                                value={pointsRuleTmp.walkover}
                                                options={[
                                                    { key: 1, text: 'NIE', value: false },
                                                    { key: 2, text: 'TAK', value: true },
                                                ]}
                                                onChange={(e, data) => {
                                                    setpointsRuleTmp({ ...pointsRuleTmp, walkover: data.value })
                                                }}

                                                label='Oznacz jako walkower'

                                            />

                                            <Button size='mini' title="Dodaj do tabeli" >Dodaj rekord</Button>



                                        </Form.Group>


                                    </Form>
                                    <Divider />
                                    <div style={{ overflowX: "auto", width: "100%" }} >
                                        <Table celled compact unstackable >
                                            <Table.Header>
                                                <Table.Row textAlign='center'>
                                                    <Table.HeaderCell>Priorytet</Table.HeaderCell>
                                                    <Table.HeaderCell>Wynik pojedynku</Table.HeaderCell>
                                                    <Table.HeaderCell>Wygrana</Table.HeaderCell>
                                                    <Table.HeaderCell>Remis</Table.HeaderCell>
                                                    <Table.HeaderCell>Przegrana</Table.HeaderCell>
                                                    <Table.HeaderCell>Walkower</Table.HeaderCell>
                                                    <Table.HeaderCell></Table.HeaderCell>
                                                    <Table.HeaderCell></Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>

                                            <Table.Body >
                                                {form.pointsRule.map((row, i) =>
                                                    <Table.Row key={i} textAlign='center'>
                                                        <Table.Cell width={1} textAlign='center'>{i + 1}</Table.Cell>
                                                        <Table.Cell>{row.member1_score === null && row.member2_score === null ? "DOWOLNY" : row.member1_score === row.member2_score ? <>{row.member1_score}:{row.member2_score}</> : <>{row.member1_score}:{row.member2_score} lub {row.member2_score}:{row.member1_score}</>}</Table.Cell>
                                                        <Table.Cell>{row.winner_score}</Table.Cell>
                                                        <Table.Cell>{row.draw_score}</Table.Cell>
                                                        <Table.Cell>{row.loser_score}</Table.Cell>
                                                        <Table.Cell>{row.walkover ? "TAK" : "NIE"}</Table.Cell>

                                                        <Table.Cell width={1} singleLine textAlign='center'>{i === 0 ? "" : <Icon className='cursorPointer' name="arrow alternate circle up" size='large' onClick={() => changeOrderRule(i, "UP")} />} {i === (form.pointsRule.length - 1) ? "" : <Icon className='cursorPointer' name="arrow alternate circle down" size='large' onClick={() => changeOrderRule(i, "DOWN")} />}</Table.Cell>
                                                        <Table.Cell width={1}><Button
                                                            icon="minus"
                                                            type="button"
                                                            fluid
                                                            title="Usuń rekord"
                                                            onClick={() => delRuleRow(row)}
                                                        /></Table.Cell>


                                                    </Table.Row>
                                                )}
                                            </Table.Body>
                                        </Table>
                                    </div>

                                    <Button style={{ marginTop: 20 }} color="green" onClick={() => saveDataDB()} fluid loading={isloading} disabled={isloading}>ZAPISZ</Button>
                                </>
                                : ''
                            }


                            {openModalBody && openModalBody.itype === "selectRowAP" ?
                                <>

                                    <Form>
                                        <Form.Group widths='equal'>

                                            <Form.Field
                                                control={Select} selectOnBlur={false}
                                                options={TournamentTypeAlgorithm}
                                                value={form.selectRowAP}
                                                onChange={(e, data) => setForm({ ...form, selectRowAP: data.value })}
                                                label='Algorytm punktacji - rozgrywanego turnieju'
                                                search
                                                placeholder='Proszę wybrać...'

                                            />


                                        </Form.Group>
                                        *Proszę wybrać prawidłowy Algorytm punktacji, ponieważ punktacje turniejowe sa naliczane zgodnie z informacja w zakładce instrukcje pole <b>Punktacje turniejowe</b>.
                                        <br /><br />
                                        <Button fluid color="green" loading={isloading} disabled={isloading} onClick={() => saveDataDB()}>ZAPISZ</Button>
                                    </Form>
                                </>
                                : ''
                            }

                            {openModalBody && openModalBody.itype === "InputKat" ?
                                <>

                                    <Form>
                                        <Form.Group widths='equal'>
                                            <Form.Field
                                                control={Input}
                                                required
                                                label={openModalBody ? openModalBody.name : ""}
                                                value={form.InputKat}
                                                onChange={(e, data) => setForm({ ...form, InputKat: data.value.toUpperCase() })}
                                            />

                                        </Form.Group>
                                        <Button fluid color="green" loading={isloading} disabled={isloading || form.InputKat === ""} onClick={() => saveDataDB()}>ZAPISZ</Button>
                                    </Form>
                                </>
                                : ''
                            }

                            {openModalBody && openModalBody.itype === "video_data" ?
                                <>

                                    <Form onSubmit={addVideoData}>
                                        <Form.Group widths='equal'>
                                            <Form.Field
                                                control={Input}
                                                required
                                                label="Nazwa video"
                                                value={videoDataTmp.name}
                                                onChange={(e, data) => setvideoDataTmp({ ...videoDataTmp, name: data.value })}
                                            />
                                            <Form.Field
                                                control={Input}
                                                required
                                                type={"url"}
                                                label="Link do video"
                                                value={videoDataTmp.url}
                                                onChange={(e, data) => setvideoDataTmp({ ...videoDataTmp, url: data.value })}
                                            />
                                            <Button >DODAJ</Button>
                                        </Form.Group>
                                        Lista linków:
                                        <List divided >
                                            {form.videoData ? form.videoData.map((row, i) =>
                                                <List.Item style={{ position: "relative" }} key={i}>
                                                    <List.Icon className='cursorPointer' name='trash' size='large' verticalAlign='middle' onClick={() => removeTextToList(i)} />
                                                    <List.Content>
                                                        <List.Header >Nazwa video: {row.name}</List.Header>
                                                        <List.Description>Url video: {row.url}</List.Description>
                                                    </List.Content>
                                                </List.Item>
                                            ) : ""}
                                        </List>

                                    </Form>
                                    <Button style={{ marginTop: 10 }} color="green" fluid loading={isloading} disabled={isloading} onClick={() => saveDataDB()}>ZAPISZ</Button>
                                </>
                                : ''
                            }
                            {openModalBody && openModalBody.itype === "google_ads" ?
                                <>
                                    <BuyAdsOff tournament_id={openModalBody.jsonBody.tournament_id} tournament_name={authContext.modalInfo.jsonBody.tournament_name} />
                                </>
                                : ''
                            }

                            {openModalBody && openModalBody.itype === "photo" ?
                                <>

                                    <Form>
                                        <Form.Group widths='equal'>
                                            <Button
                                                content="Wybierz plik graficzny/plakat"
                                                labelPosition="left"
                                                style={{ marginTop: 10, marginBottom: 10 }}
                                                fluid
                                                icon="file"
                                                type="button"
                                                onClick={() => fileInputRef.current.click()}
                                            />
                                            {form.InputPhoto ?
                                                <Button
                                                    content="Usuń plik"
                                                    labelPosition="left"
                                                    style={{ marginTop: 10, marginBottom: 10 }}
                                                    fluid
                                                    icon="trash"
                                                    type="button"
                                                    onClick={clearImageChange}
                                                />
                                                : ""}
                                        </Form.Group>
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            accept="image/*"
                                            hidden
                                            onChange={onImageChange}
                                        />
                                        <Container textAlign='center'>
                                            <label>{form.InputPhoto ? "" : "Brak wybranego pliku"}</label>
                                            <Image style={{ margin: "0 auto" }} src={form.InputPhoto ? form.InputPhoto : "https://turniej-generator.pl/img/noimg.png"} size='large' alt="logo" />
                                        </Container>
                                        <br />
                                        <Button loading={isloading} color="green" disabled={isloading} style={{ marginTop: 10, marginBottom: 10 }} fluid onClick={() => saveDataDB()}>ZAPISZ</Button>
                                    </Form>
                                </>
                                : ''
                            }

                            {statusError.show ?
                                <Message error size='small'
                                    icon='exclamation circle'
                                    header='Błąd'
                                    content={statusError.message}
                                />
                                : ""}
                        </Modal.Content>
                    </>
                    :
                    <>
                        <Modal.Header >
                            <Grid stackable>
                                <Grid.Row>
                                    <Grid.Column width={12} verticalAlign="middle">
                                        <Header as='h2' textAlign='center'>
                                            <Icon name='info circle' color={authContext.modalInfo && authContext.modalInfo.nameModal === "ADDTS" ? "blue" : "red"} />
                                            <Header.Content> {authContext.modalInfo ? authContext.modalInfo.name : ""}</Header.Content>
                                        </Header>
                                    </Grid.Column>
                                    <Grid.Column width={4} textAlign="right" only='large screen'>
                                        <Image floated='right'  style={{maxWidth:200}} centered src={LogoTeamLigaGenerator} alt="logo" />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>

                        </Modal.Header>
                        <Modal.Content scrolling={authContext.modalInfo && (authContext.modalInfo.nameModal === "SearchTournamentTG" || authContext.modalInfo.nameModal === "WynikiSzczegolowe" || authContext.modalInfo.nameModal === "buyCoffe" || authContext.modalInfo.nameModal === "ChangeMyData" || authContext.modalInfo.nameModal === "MatchReport" || authContext.modalInfo.nameModal==="limitMembers") ? false : width > 700 ? true : false}>
                            {authContext.modalInfo && authContext.modalInfo.nameModal === "buyCoffe" ?
                                <BuyCoffe />
                                :
                                authContext.modalInfo && authContext.modalInfo.nameModal === "buyCoffeQuestions" ?
                                    <Container textAlign='center'>
                                        <Header as='h4' icon>
                                            <Icon name='thumbs up' />
                                            GRATULACJE
                                            <Header.Subheader>
                                                Zakończyłeś/aś rozgrywać turniej, mamy nadzieję, że wszystko było proste i intuicyjne.
                                                Jeżeli doceniasz naszą aplikację w ramach wdzięczności możesz postawić nam wirtualną kawę.


                                            </Header.Subheader>
                                        </Header>
                                        <BuyCoffeStart />


                                        <Button fluid animated='fade' onClick={() => closeOpenModal()}>
                                            <Button.Content visible>INNYM RAZEM</Button.Content>
                                            <Button.Content hidden>A MOŻE JEDNAK DASZ SIĘ NAMÓWIĆ NA KAWĘ?</Button.Content>
                                        </Button>


                                    </Container>

                                    : authContext.modalInfo && authContext.modalInfo.nameModal === "generateHotPayDataUpgradeTournamentMembersToLictl" ?
                                        <Container textAlign='center'>
                                            <Header as='h4' icon>
                                                <Icon name='thumbs up' color='green' />
                                                GRATULACJE
                                                <Header.Subheader style={{ marginTop: 10 }}>
                                                    Właśnie zakończyłeś/aś rozgrywki w bezpłatnym pakiecie brązowym. Za jedyne 9 złotych możesz każdemu z uczestników rozgrywek (całego turnieju niezależnie od ilości kategorii)
                                                    zapewnić dostęp do szczegółowych statystyk,
                                                    dzięki czemu będzie mógł śledzić swoje postępy oraz porównywać się z innymi uczestnikami Turniej-Generator!
                                                    <Grid style={{ marginTop: 10 }}>
                                                        <Grid.Row textAlign='center' verticalAlign='middle' columns={3}>
                                                            <Grid.Column >
                                                                <MyImageLazy openView={false} src={process.env.REACT_APP_PUBLIC_URL + "/img/info/1.png"} alt="info1" />
                                                                <br />Porównanie zawodników H2H
                                                            </Grid.Column>
                                                            <Grid.Column >
                                                                <MyImageLazy openView={false} src={process.env.REACT_APP_PUBLIC_URL + "/img/info/2.png"} alt="info2" />
                                                                <br />Rozegrane turnieje/ligi
                                                            </Grid.Column>
                                                            <Grid.Column >
                                                                <MyImageLazy openView={false} src={process.env.REACT_APP_PUBLIC_URL + "/img/info/3.png"} alt="info3" />
                                                                <br />Zdobyte osiągnięcia
                                                            </Grid.Column>

                                                        </Grid.Row>
                                                    </Grid>

                                                </Header.Subheader>
                                            </Header>
                                            <BuyUpgradeTournamentMembers tournament_id={authContext.modalInfo.value} />


                                            <Button fluid animated='fade' onClick={() => closeOpenModal()}>
                                                <Button.Content visible>INNYM RAZEM</Button.Content>
                                                <Button.Content hidden>A MOŻE JEDNAK DASZ SIĘ NAMÓWIĆ?</Button.Content>
                                            </Button>


                                        </Container>
                                        :
                                        authContext.modalInfo && authContext.modalInfo.nameModal === "RELO" ?

                                            <Container textAlign='center'>

                                                Ranking ELO – ranking stosowany do określenia mocy przeciwnika/drużyny przeciwnej. Został oparty na rankingu szachowym autorstwa Arpada Elo. Zaletą tego rankingu jest możliwość <strong>sprawdzenia mocy uczestnika</strong> w dowolnym momencie historii. Punkty przyznawane są za odbyte pojedynki.
                                                <br /><br />Każdy uczestnik zaczyna z rankingiem 1500
                                                <br />
                                                <div style={{ fontSize: 12, lineHeight: "15px", margin: 5 }}>
                                                    K = 3 gdzie 0-X-16<br />
                                                    K = 13 gdzie 17-X-29<br />
                                                    K = 23 gdzie 30-X-49<br />
                                                    K = 35 gdzie 50-X-69<br />
                                                    K = 45 gdzie 70-X-99<br />
                                                    K = 60 gdzie 100-X-infinite<br />
                                                    X - ilość osób w danej kategorii rozgrywanego turnieju</div>
                                                <a href="https://pl.wikipedia.org/wiki/Ranking_szachowy" target={"_blank"} rel="noopener noreferrer"> Ranking ELO - (Elo na Wikipedii)</a> lub
                                                <a href="https://pl.wikipedia.org/wiki/Ranking_Elo_(piłka_nożna)" target={"_blank"} rel="noopener noreferrer"> Ranking ELO - (Elo na Wikipedii)</a>
                                            </Container>

                                            : authContext.modalInfo && authContext.modalInfo.nameModal === "AllowMembersSetScores" ?

                                                <div >
                                                    {AllowMembersSetScores(authContext.modalInfo.value)}
                                                </div>

                                                : authContext.modalInfo && authContext.modalInfo.nameModal === "globalViewValue" ?

                                                    <Container textAlign='center'>
                                                        {authContext.modalInfo.value}
                                                    </Container>

                                                    : authContext.modalInfo && authContext.modalInfo.nameModal === "ChangeMyData" ?

                                                        <Container >
                                                            <ChangeMyData hiddenDelAccount={true} closeOpenModal={closeOpenModal} />
                                                            <Divider />
                                                            <Button style={{ marginTop: 20 }} color='grey' fluid size='mini' onClick={() => closeOpenModal()}>ZAMKNIJ INFORMACJĘ

                                                            </Button>

                                                        </Container>

                                                        : authContext.modalInfo && authContext.modalInfo.nameModal === "ADDTS" ?

                                                            <Container textAlign='center'>
                                                                <Header as='h2' icon textAlign='center'>
                                                                    <Icon className='infoTG' color={authContext.modalInfo.error ? 'red' : 'green'} name={authContext.modalInfo.error ? "exclamation circle" : "check circle"} />
                                                                    <Header.Subheader style={{ marginTop: 20, marginBottom: 20, color: "#000" }}>
                                                                        {authContext.modalInfo.value}
                                                                    </Header.Subheader>
                                                                </Header>



                                                                <Button style={{ marginTop: 60 }} fluid size='mini' onClick={() => closeOpenModal()}>ZAMKNIJ INFORMACJĘ

                                                                </Button>


                                                            </Container>

                                                            : authContext.modalInfo && authContext.modalInfo.nameModal === "GLICKO" ?

                                                                <Container textAlign='center'>
                                                                    Ranking GLICKO – ranking stosowany do określenia mocy przeciwnika/drużyny przeciwnej. Zaletą tego rankingu jest możliwość <strong>sprawdzenia mocy uczestnika</strong> w dowolnym momencie historii. Punkty przyznawane są za odbyte pojedynki <a href="https://en.wikipedia.org/wiki/Glicko_rating_system" target={"_blank"} rel="noopener noreferrer"> metodą Glicko</a>
                                                                </Container>

                                                                :authContext.modalInfo && authContext.modalInfo.nameModal === "limitMembers" ?

                                                               
                                                             <LimitMebersTournament />

                                                                :
                                                                authContext.modalInfo && authContext.modalInfo.nameModal === "SupportTournament" ?
                                                                    <BuySupport propsParamsT={authContext.modalInfo.value} />

                                                                    : authContext.modalInfo && authContext.modalInfo.nameModal === "BuyTestHotPay" ?
                                                                        <BuyTestHotPay propsParamsT={authContext.modalInfo.value} />

                                                                        :
                                                                        authContext.modalInfo && authContext.modalInfo.nameModal === "PackagesGTL" ?

                                                                            <PackagesGTL />

                                                                            : authContext.modalInfo && authContext.modalInfo.nameModal === "ChangeSubTournamentName" ?

                                                                                <ChangeSubTournamentName valuView={authContext.modalInfo.value} />

                                                                                : authContext.modalInfo && authContext.modalInfo.nameModal === "VideoModal" ?

                                                                                    <ReactPlayer controls={true} url={authContext.modalInfo.value} width={"100%"} style={{ overflow: "hidden" }} height={500} />

                                                                                    : authContext.modalInfo && authContext.modalInfo.nameModal === "MatchReport" ?
                                                                                        authContext.modalInfo.value.includes(".pdf") ?
                                                                                            <object data={authContext.modalInfo.value} type="application/pdf" frameborder="0" width="100%" height="1200px">
                                                                                                <p>Oops! Your browser doesn't support PDFs!</p>
                                                                                                <p><a className={"tllink"} href={authContext.modalInfo.value} target="_blank" rel="noopener noreferrer">Download Instead</a></p>
                                                                                            </object> : <center><MyImageLazy maxHeight={700} openView={true} alt="plakat" src={authContext.modalInfo.value} /></center>

                                                                                        :
                                                                                        authContext.modalInfo && authContext.modalInfo.nameModal === "TCharytatywny" ?

                                                                                            <TurniejCharytatywny />

                                                                                            : authContext.modalInfo && authContext.modalInfo.nameModal === "SearchTournamentTG" ?

                                                                                                <SearchTournamentTG />

                                                                                                : authContext.modalInfo && authContext.modalInfo.nameModal === "WynikiSzczegolowe" ?
                                                                                                    <ShowScoreDetailsView {...authContext.modalInfo.value} />
                                                                                                    : authContext.modalInfo && authContext.modalInfo.nameModal === "ruauto" ?
                                                                                                        participantsSolutions()
                                                                                                        : authContext.modalInfo && authContext.modalInfo.nameModal === "faq" ?
                                                                                                            <><Faq hiddenHeader={true} /></>
                                                                                                            :
                                                                                                            authContext.modalInfo && (authContext.modalInfo.nameModal === "CUP_SIMPLE"
                                                                                                                || authContext.modalInfo.nameModal === "CUP_DOUBLE_ELIMINATION"
                                                                                                                || authContext.modalInfo.nameModal === "CUP_N_ELIMINATION_SIMPLE"
                                                                                                                || authContext.modalInfo.nameModal === "CUP_N_ELIMINATION_DOUBLE"
                                                                                                                || authContext.modalInfo.nameModal === "CUP_BRASIL"
                                                                                                                || authContext.modalInfo.nameModal === "CUP_N_PLACE"
                                                                                                                || authContext.modalInfo.nameModal === "GROUPS_CUP"
                                                                                                                || authContext.modalInfo.nameModal === "GROUP"
                                                                                                                || authContext.modalInfo.nameModal === "SWISS"
                                                                                                                || authContext.modalInfo.nameModal === "SWISS_CUP"
                                                                                                                || authContext.modalInfo.nameModal === "LEAGUE"
                                                                                                                || authContext.modalInfo.nameModal === "INDIVIDUAL"
                                                                                                            ) ?
                                                                                                                getInfoTournamentSystem(authContext.modalInfo.nameModal)
                                                                                                                :
                                                                                                                <Markup content={openModalBody} />

                            }



                        </Modal.Content>
                        {authContext.modalInfo && authContext.modalInfo.showButtonClose ?
                            <ModalActions>
                                <Button onClick={() => closeOpenModal()}>
                                    ZAMKNIJ
                                </Button>

                            </ModalActions>
                            : ""}
                    </>


                }
            </Modal>

        </>
    )
}

export default ModalInfo;